var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KBreadcrumbs',{attrs:{"items":[
    { text: 'Home', link: { path: '/' } },
    { text: 'Data', link: { path: '/' } },
    {
      text: 'Very long breadcrumb that should truncate properly when displayed in the component',
      link: { path: '/long' },
    },
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }